import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpErrorResponse } from '@angular/common/http';
import { environment } from '@environments/environment';
import { ApiResponse } from '@app/_models';
import { RateManager } from '@app/_components/rate/rate-manager';
import { retry, catchError } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import { AlertService } from '@app/_services';
import { SharedService } from './../../_shared/shared.service';

@Injectable({ providedIn: 'root' })
export class RateManagerService
{
	constructor
		(
			private http: HttpClient,
			private alertService: AlertService,
			private sharedService: SharedService
		) { }

	urlEndpoint = 'rate-managers';

	add(rateManager: RateManager): Observable<ApiResponse>
	{
		console.log('posting... ' + JSON.stringify(rateManager));
		return this.http.post<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}`, rateManager);
	}

	update(rateManager: RateManager): Observable<ApiResponse>
	{
		return this.http.patch<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}`, rateManager);
	}

	delete(rateManagerId: number): Observable<ApiResponse>
	{
		return this.http.delete<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/${rateManagerId}`);
	}

	findAll(): Observable<ApiResponse>
	{
		return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}`).pipe(retry({ count: 2, delay: 1500 }));
	}

	findByFilter(page: any, size: any, sortBy: any, sortOrder: any, multiSortMeta, globalFilter: any, filters: any): Observable<ApiResponse>
	{

		let params = this.sharedService.prepareParamsFromPrimeNgDataTable(page, size, sortBy, sortOrder, multiSortMeta, globalFilter, filters);
		return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}`, { params: params }).pipe(retry({ count: 2, delay: 1500 }));
	}

	findById(id: number): Observable<ApiResponse>
	{
		return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/${id}`).pipe(retry({ count: 2, delay: 1500 }));
	}
	getOccupancySummary(id: number): Observable<ApiResponse>
	{
		return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/occupancy-summary/${id}`);
	}
	getAdvertisedRatesByShortTermRentalId(shortTermRentalId: number): Observable<ApiResponse>
	{
		return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/advertised-rates/${shortTermRentalId}`);
	}

	getAdvertisedRates(searchForm): Observable<ApiResponse>
	{
		return this.http.post<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/advertised-rates/`, searchForm);
	}

	getLosRates(searchForm): Observable<ApiResponse>
	{
		return this.http.post<ApiResponse>(`${environment.apiUrl}/rate-detail-los/search/`, searchForm);
	}

	generateLosRatesByShortTermRentalId(shortTermRentalId): Observable<ApiResponse>
	{
		return this.http.get<ApiResponse>(`${environment.apiUrl}/rate-detail-los/generate/${shortTermRentalId}`);
	}

	generateLosRatesByRateBucketId(rateBucketId): Observable<ApiResponse>
	{
		return this.http.get<ApiResponse>(`${environment.apiUrl}/rate-detail-los/generate/rate-bucket/${rateBucketId}`);
	}


	audit(id: number): Observable<ApiResponse>
	{
		return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/${id}/audit`).pipe(retry({ count: 2, delay: 1500 }));
	}


	prepareParamsFromPrimeNgDataTable(page: any, size: any, sortBy: any, sortOrder: any, multiSortMeta, globalFilter: any, filters: any)
	{
		try
		{
			console.log(
				'  |  page:' + page
				+ '  |  size:' + size
				+ '  |  sortBy:' + sortBy
				+ '  |  sortOrder:' + sortOrder
				+ '  |  multiSortMeta:' + JSON.stringify(multiSortMeta)
				+ '  |  globalFilter:' + globalFilter
				+ '  |  filters:' + JSON.stringify(filters)
			);

			let params = new HttpParams();

			if (!isNaN(page)) { params = params.append('page', page); }
			if (!isNaN(size)) { params = params.append('size', size); }
			if (sortBy) { params = params.append('sort', sortBy + ',' + (sortOrder === 1 ? 'asc' : 'desc')); }
			if (multiSortMeta)
			{
				// if sortMode="multiple" in primeng table then multiSortMeta is used for ALL sorting (even just one column.)
				// Otherwise, single sorting is used above.
				// event.multiSortMeta:[{"field":"lastName","order":1},{"field":"firstName","order":1}]
				for (let i = 0; i < multiSortMeta.length; i++)
				{
					let json = JSON.parse(JSON.stringify(multiSortMeta[i]));
					params = params.append('sort', json.field + ',' + (json.order === 1 ? 'asc' : 'desc'));
				}
			}
			// globalFilter works, but did not implemnt in Spring but not hard to write custom findAll and specify certain columns to look.
			if (globalFilter) { params = params.append('filter', globalFilter); }

			// multiselect or input or whatever... these work slick.
			if (filters)
			{
				// key:status val:{"value":["A"],"matchMode":"in"}
				for (let i = 0, keys = Object.keys(filters), ii = keys.length; i < ii; i++)
				{
					console.log('key:' + keys[i] + ' val:' + JSON.stringify(filters[keys[i]]));
					params = params.append(keys[i], filters[keys[i]].value);
				}
			}
			return params;
		} catch (error)
		{
			console.log('prepareParamsFromPrimeNgDataTable()' + error);
		}
	}
}
